<div [formGroup]="form" [class.training-completion-gate-blocked]="isTrainingCompletionBlocked">
	<div *ngIf="isAdmin" class="form-group d-flex align-items-center training-type-group">
		<label class="form-control-label me-2 mb-0" for="trainingTypeId">Tipo de treinamento</label>
		<a href="javascript:void(0)" class="link-primary d-flex align-items-center px-2" (click)="openTrainingModal()">
			Gerenciar Treinamentos
		</a>
	</div>

	<div *ngIf="!isHidden('trainingTypeId')" class="form-group">
		<ng-select class="auto-grow-options" [items]="trainingOptions" bindValue="value" bindLabel="label"
			placeholder="Tipo de treinamento" formControlName="trainingTypeId">
		</ng-select>
		<app-error-msg [control]="form.controls['trainingTypeId']" [label]="'trainingTypeId'"></app-error-msg>
	</div>

	<div class="form-group" *ngIf="data?.mode === 'add'">
		<label class="form-control-label" for="">Colaborador</label>

		<ng-container *ngIf="data?.hasSubType">
			<div class="form-group">
				<ng-select class="auto-grow-options" [items]="lists.activeEmployees" bindValue="id" bindLabel="name"
					placeholder="Colaborador" formControlName="employeeId" (change)="onActiveEmployeeChanged($event)">
				</ng-select>
			</div>
		</ng-container>

		<ng-container *ngIf="!data?.hasSubType">
			<app-employee-info-display [employee]="data?.employee"></app-employee-info-display>
		</ng-container>
	</div>

	<div *ngIf="!isHidden('costCenterId')" class="form-group">
		<label class="form-control-label" for="costCenterId">Centro de custo para o treinamento</label>
		<ng-select class="cost-centers-options auto-grow-options"
			[attr.data-tooltip]="getSelectedOptionText(lists.centerCostsOptions, form.get('costCenterId')?.value)"
			[items]="lists.centerCostsOptions" bindValue="value" bindLabel="label" placeholder="Selecionar"
			(change)="onTrainingCenterCostChanged($event, 'costCenterId')" formControlName="costCenterId"
			[readonly]="data?.hasSubType">
		</ng-select>
		<app-error-msg [control]="form.controls['costCenterId']" [label]="'costCenterId'"></app-error-msg>
	</div>

	<div *ngIf="!isHidden('jobTitleGroupId')" class="form-group">
		<label class="form-control-label" for="group">Cargo para o treinamento</label>
		<ng-select class="auto-grow-options" title="Cargo para o treinamento" [items]="lists.jobTitleGroupOptions"
			bindValue="value" bindLabel="label" placeholder="Selecionar" formControlName="jobTitleGroupId"
			(change)="onJobTitleGroupChanged($event)" [readonly]="data?.hasSubType" [loading]="isJobTitleGroupsLoading">
		</ng-select>
		<app-error-msg [control]="form.controls['jobTitleGroupId']" [label]="'jobTitleGroupId'"></app-error-msg>
	</div>

	<div *ngIf="!isHidden('jobTitleId')" class="form-group">
		<label class="form-control-label" for="group">Função para o treinamento</label>
		<ng-select class="cost-centers-options auto-grow-options"
			[attr.data-tooltip]="getSelectedOptionText(lists.jobTitleOptions, form.get('jobTitleId')?.value)"
			[items]="lists.jobTitleOptions" bindValue="value" bindLabel="label" placeholder="Selecionar"
			formControlName="jobTitleId" [readonly]="isJobtitleDisabled" [loading]="isJobTitlesLoading"
			(change)="onJobTitleChanged($event)">
		</ng-select>
		<app-error-msg [control]="form.controls['jobTitleId']" [label]="'jobTitleId'"></app-error-msg>
	</div>

	<app-salary-range-select *ngIf="!isHidden('salaryRange')" [jobTitleId]="form.get('jobTitleId')?.value" [control]="form.controls['salaryRange']"
		[required]="isSalaryRangeRequired" (rangeSelected)="onSalaryRangeSelected($event)"></app-salary-range-select>

	<div class="form-group">
		<label class="form-control-label" for="workScaleGroup">Turno para o treinamento</label>
		<ng-select class="auto-grow-options" [items]="lists.workScaleGroupOptions" bindValue="value" bindLabel="label"
			placeholder="Turno" formControlName="workScaleGroup" title="Turno" [readonly]="data?.mode === 'details'"
			[loading]="isWorkScaleGroupsLoading">
		</ng-select>
		<app-error-msg [control]="form.controls['workScaleGroup']" [label]="'Turno'"></app-error-msg>
	</div>

	<ng-container *ngIf="canShowFieldToStartTraining">
		<div *ngIf="!isHidden('startTrainingDate')" class="form-group">
			<label class="form-control-label" for="">Data início</label>
			<input type="date" class="form-control" formControlName="startTrainingDate"
				(change)="onStartDateChange($event)" />
			<app-error-msg [control]="form.controls['startTrainingDate']" [label]="'Data início'"></app-error-msg>
		</div>
	</ng-container>

	<ng-container *ngIf="canShowFieldToEndTraining">
		<div *ngIf="!isHidden('endTrainingDate')" class="form-group">
			<label class="form-control-label" for="">Data fim</label>
			<input type="date" class="form-control" formControlName="endTrainingDate" />
			<app-error-msg [control]="form.controls['endTrainingDate']" [label]="'Data fim'"></app-error-msg>
		</div>

		<div *ngIf="!isHidden('isApproved')" class="form-group">
			<label class="form-control-label">O colaborador está APTO para a função?</label>
			<select class="form-control" id="isApproved" formControlName="isApproved">
				<option [ngValue]="null" disabled selected>Selecione</option>
				<option [ngValue]="true">SIM</option>
				<option [ngValue]="false">NÃO</option>
			</select>
			<app-error-msg [control]="form.controls['isApproved']" [label]="'isApproved'"></app-error-msg>
		</div>
	</ng-container>


	<div class="form-group" *ngIf="(canShowFieldsToChangeJobTitleTrained) && !isHidden('changeTypeCode')">
		<label class="form-control-label" for="changeTypeCode">Tipo de movimentação</label>
		<ng-select class="cost-centers-options auto-grow-options" title="Tipo de movimentação"
			[items]="lists.movementTypeOptions" bindValue="value" bindLabel="label" placeholder="Tipo de movimentação"
			formControlName="changeTypeCode">
		</ng-select>
		<app-error-msg [control]="form.controls['changeTypeCode']" [label]="'changeTypeCode'"></app-error-msg>
	</div>

	<div class="form-group" *ngIf="(canShowExecutionDate) && !isHidden('executionDate')">
		<label class="form-control-label" for="">Data da Execução</label>
		<input type="date" class="form-control" formControlName="executionDate" />
		<app-error-msg [control]="form.controls['executionDate']" [label]="'Data da Execução'"></app-error-msg>
	</div>

	<div class="form-group" *ngIf="(canShowFieldsToChangeJobTitleTrained && !hasSalaryRange) && !isHidden('newSalary')">
		<label class="form-control-label" for="newSalary">Salário</label>
		<input type="text" id="newSalary" formControlName="newSalary" class="form-control" placeholder="R$ 0,00"
			appCurrencyCentsInput />
		<app-error-msg [control]="form.controls['newSalary']" [label]="'newSalary'"></app-error-msg>
	</div>

	<div class="form-group" *ngIf="(canShowTradeUnionField) && !isHidden('tradeUnionId')">
		<label class="form-control-label" for="group">Sindicato</label>
		<ng-select class="cost-centers-options auto-grow-options"
			[attr.data-tooltip]="getSelectedOptionText(lists.tradeUnionsOptions, form.get('tradeUnionId')?.value)"
			[items]="lists.tradeUnionsOptions" bindValue="value" bindLabel="label" placeholder="Sindicato da nova função"
			formControlName="tradeUnionId">
		</ng-select>
		<app-error-msg [control]="form.controls['tradeUnionId']" [label]="'tradeUnionId'"></app-error-msg>
	</div>

	<div class="form-group" *ngIf="(canShowUnhealthinessField) && !isHidden('unhealthinessType')">
		<label class="form-control-label">Insalubridade</label>
		<ng-select container="body" class="cost-centers-options auto-grow-options" title="Insalubridade"
			[items]="unhealthinessOptions" bindValue="value" bindLabel="label" placeholder="Insalubridade"
			[readonly]="!canEditFieldToApproveUnhealthiness" formControlName="unhealthinessType">
		</ng-select>
		<app-error-msg [control]="form.controls['unhealthinessType']" [label]="'unhealthinessType'"></app-error-msg>
	</div>

	<div class="form-group" *ngIf="(canShowDangerousnessField) && !isHidden('hasDangerousness')">
		<div class="d-flex gap-2 mb-small">
			<label class="form-control-label">Possui Periculosidade?</label>
			<div class="custom-control custom-switch custom-switch-success">
				<input type="checkbox" class="custom-control-input" id="hasDangerousness" formControlName="hasDangerousness" />
				<label class="form-control-label custom-control-label" for="hasDangerousness">
					<span class="switch-icon-left"><i data-feather="check"></i></span>
					<span class="switch-icon-right"><i data-feather="x"></i></span>
				</label>
			</div>
		</div>
	</div>

	<div class="form-group">
		<label class="form-control-label" for="">Observações</label>
		<textarea type="text" class="form-control" formControlName="note"></textarea>
		<app-error-msg [control]="form.controls['note']" [label]="'note'"></app-error-msg>
	</div>
</div>